module.exports = __webpack_public_path__ + "img/20.42518ddb.jpg";